<template>
  <div>
    <div class="button-body">
      <van-button type="danger" @click="approval(2)">拒绝申请</van-button>
      <van-button type="info" @click="approval(1)">通过申请</van-button>
    </div>
    <van-dialog
      v-model="show"
      title="填写不通过说明"
      show-cancel-button
      confirm-button-text="提交"
      @confirm="confirm"
    >
      <div style="padding: 15px">
        <van-field
          v-model="message"
          rows="3"
          autosize
          label="说明"
          type="textarea"
          placeholder="请输入说明"
        />
      </div>
    </van-dialog>
    <van-dialog
      v-model="moneyShow"
      title="输入退款金额"
      show-cancel-button
      confirm-button-text="提交"
      @confirm="moneyConfirm"
    >
      <div style="padding: 15px">
        <van-field
          v-model="money"
          type="number"
          label="金额¥"
          placeholder="请输入退款金额"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "auditBtn",
  data() {
    return {
      form: {},
      show: false, //显示隐藏拒绝原因
      message: null, //拒绝申请原因
      money: null, //通过审核,输入金额
      moneyShow: false, //显示输入金额
    };
  },
  props: {
    content: {
      type: Object,
      default: function () {
        console.log(this.content);
      },
    },
  },
  methods: {
    approval(type) {
      if (type == 2) {
        //拒绝申请
        this.show = true; //显示输入拒绝原因
      } else {
        if (this.content.check_status == 2) {
          //通过申请输入金额
          this.moneyShow = true;
        } else {
          //普通通过申请
          this.emitServer(1);
        }
      }
    },
    //提交拒绝原因
    confirm() {
      if (!this.message) {
        Toast.fail("请填写说明");
      } else {
        this.emitServer(2);
      }
    },
    //提交输入金额
    moneyConfirm() {
      if (!this.money) {
        Toast.fail("请输入金额");
      } else {
        this.emitServer(1);
      }
    },
    //传送数据
    emitServer(type) {
      this.$emit("audit", {
        type: type,
        recede_remark: this.message,
        recede_amount: this.money,
      });
      this.message = null;
      this.money = null;
    },
  },
};
</script>

<style>
.button-body {
  padding: 0 15%;
  margin-top: 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
